
import Vue from 'vue'
import { ElForm } from 'element-ui/types/form'
import { getHotelList } from '@/api/hotel'
export default Vue.extend({
	data() {
		return {
			hotels: [] as any,
			hotelInfoDialog: false,
			checkDialog: false,
			hotel_submit_form: {
				id: '',
				linkman: '',
				phone: '',
				code: '',
			},
			hotel_submit_form_rules: {
				hotel_name: [{ required: true, message: '请输入酒店名称', trigger: 'blur' }],
				hotel_code: [{ required: true, message: '请输入酒店code', trigger: 'blur' }],
				pms_hotel_id: [{ required: true, message: '请输入PMS酒店id', trigger: 'blur' }],
			},
			isChecked: true,
			editStatus: 0,
			submit_form: {
				hotel_id: '',
				linkman: '',
				email: '',
				account: '',
				backname: '',
				backaccount: '',
			},
			submit_form_rules: {
				hotel_id: [{ required: true, message: '请输入酒店名称', trigger: 'blur' }],
				phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
				linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
				account: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
				backname: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
				backaccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
			},
			backInfoDialog: false,
		}
	},
	created() {
		getHotelList().then((res) => {
			if (res.code == 0) {
				// 超级管理员/ota管理员有全部权限
				if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
					this.hotels = [{ id: 0, name: '全部' }].concat(res.data.rows)
				} else {
					this.hotels = res.data.rows
				}
				// this.searchForm.pms_hotel_code = this.hotels[0].miccode
				// this.searchForm.pms_hotel_id = this.hotels[0].id
			}
		})
	},
	methods: {
		changeBackInfo() {
			if (this.isChecked === false) {
				this.checkDialog = true
				return
			}
			this.backInfoDialog = true
		},
		changeHotelInfo() {
			if (this.isChecked === false) {
				this.checkDialog = true
				return
			}
			this.hotelInfoDialog = true
		},
		closecheckDialog() {
			this.checkDialog = false
		},
		submitForm(formName: string) {
			;(this.$refs[formName] as ElForm).validate((valid) => {
				if (valid) {
					console.log(formName)
				} else {
					return false
				}
			})
		},
	},
})
